import { Component, OnInit, signal, inject } from '@angular/core';
import { UserService } from '../../shared/core/state/users/users.service';
import { linkedAccountsResponse } from '../../shared/core/state/users/models';
import { StorageService } from '../../shared/util/storage.service';
import { CONST } from '../../shared/util/const';
import { environment } from '../../../../src/environments/environment';
import { finalize } from 'rxjs';

@Component({
  selector: 'black-app-management',
  standalone: false,
  templateUrl: './app-management.component.html',
  styleUrl: './app-management.component.css',
})
export class AppManagementComponent implements OnInit {
  private userService = inject(UserService);
  private storageService = inject(StorageService);

  isPageLoading = signal(false);
  isUnlinking = signal(false);

  zoomAccount = signal<linkedAccountsResponse | null>(null);

  ngOnInit(): void {
    this.loadZoomAccount();
  }

  private loadZoomAccount(): void {
    this.isPageLoading.set(true);
    this.userService
      .getUserInfo()
      .pipe(finalize(() => this.isPageLoading.set(false)))
      .subscribe((data) => {
        const zoom = (data.linkedAccounts ?? []).find(
          (a) => a.provider === 'zoom'
        );
        this.zoomAccount.set(zoom ?? null);
      });
  }

  async connectZoomAccount(): Promise<void> {
    const returnUrl = '/dashboard/app-management';
    const state = crypto.randomUUID();
    await this.storageService.set(CONST.STORAGE_KEYS.ZOOM_RETURN_URL, returnUrl);
    await this.storageService.set(CONST.STORAGE_KEYS.ZOOM_OAUTH_STATE, state);
    const redirectUrl = `${window.location.origin}/auth/zoom-callback`;
    const authUrl = `https://zoom.us/oauth/authorize?response_type=code&client_id=${environment.zoomAppKey}&redirect_uri=${encodeURIComponent(redirectUrl)}&state=${encodeURIComponent(state)}`;
    window.location.href = authUrl;
  }

  unlinkZoomAccount(): void {
    const account = this.zoomAccount();
    if (!account) return;
    this.isUnlinking.set(true);
    this.userService
      .unlinkAccount(account.provider, account.userId)
      .pipe(finalize(() => this.isUnlinking.set(false)))
      .subscribe({
        next: () => {
          this.zoomAccount.set(null);
        },
      });
  }
}
